/**
 * Product FOMO & Sold Today Badge
 * Persistent, realistic dynamic items sold count per product/day
 */
(function () {
  'use strict';

  function getTodayKey() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  function getSeedNumber(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function initProductFomo() {
    const fomoContainers = document.querySelectorAll('.product-fomo');
    if (!fomoContainers.length) return;

    const today = getTodayKey();

    fomoContainers.forEach((container) => {
      const productId = container.dataset.productId || 'default';
      const minSold = parseInt(container.dataset.minSold, 10) || 4;
      const maxSold = parseInt(container.dataset.maxSold, 10) || 18;

      const soldCountEl = container.querySelector('[data-fomo-sold-count]');
      const viewersEl = container.querySelector('[data-fomo-viewers]');
      const ordersEl = container.querySelector('[data-fomo-orders]');

      const storageKey = `monvico_fomo_${productId}`;

      let fomoData = null;
      try {
        fomoData = JSON.parse(localStorage.getItem(storageKey));
      } catch (e) {
        fomoData = null;
      }

      // Check if data exists and is from today
      if (!fomoData || fomoData.date !== today) {
        const seed = getSeedNumber(`${productId}-${today}`);
        const range = Math.max(1, maxSold - minSold + 1);
        const dynamicSold = minSold + (seed % range);

        fomoData = {
          date: today,
          sold: dynamicSold,
          viewers: Math.floor(Math.random() * (36 - 16 + 1)) + 16,
          orders: Math.floor(Math.random() * (7 - 2 + 1)) + 2,
        };

        try {
          localStorage.setItem(storageKey, JSON.stringify(fomoData));
        } catch (e) {
          // Fallback if localStorage quota exceeded
        }
      }

      // Populate Sold Count
      if (soldCountEl && fomoData.sold) {
        soldCountEl.textContent = fomoData.sold;
      }

      // Populate Viewers
      if (viewersEl && fomoData.viewers) {
        viewersEl.textContent = fomoData.viewers;
      }

      // Populate Orders
      if (ordersEl && fomoData.orders) {
        ordersEl.textContent = fomoData.orders;
      }

      // Subtle live dynamic increment simulation (rare +1 after 35-65s on page)
      if (soldCountEl && !container.dataset.fomoTimerSet) {
        container.dataset.fomoTimerSet = 'true';
        const delay = Math.floor(Math.random() * (65000 - 35000 + 1)) + 35000;

        setTimeout(() => {
          if (fomoData.sold < maxSold) {
            fomoData.sold += 1;
            soldCountEl.textContent = fomoData.sold;
            soldCountEl.classList.remove('is-updated');
            // Trigger reflow to restart CSS animation
            void soldCountEl.offsetWidth;
            soldCountEl.classList.add('is-updated');

            try {
              localStorage.setItem(storageKey, JSON.stringify(fomoData));
            } catch (e) {}
          }
        }, delay);
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFomo);
  } else {
    initProductFomo();
  }

  // Shopify Theme Editor & Dynamic Section load support
  document.addEventListener('shopify:section:load', initProductFomo);
  document.addEventListener('shopify:block:select', initProductFomo);
})();
